import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';



@Component({
    selector: 'btn-cell-renderer-save',
    template: `
	<em *ngIf="show_signup">
	<img style="padding-right:16px;color-red" src="./assets/images/edit_blue.svg" 
	(click)="btnClickedHandler($event,'signup')" style="cursor:pointer;"> 
	</em>
	`,
    standalone: false
})
export class BtnCellRendererSignup implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	show_signup: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;
		if (this.params.data.roundComplete == 1) {  // NOSONAR
			this.show_signup = false;
		}

		if (this.params.data.statusId == 1) {  // NOSONAR
			this.show_signup = true;
		}

		if(this.params.keyParam == false){  // NOSONAR
			this.show_signup = false;
		}
	}

	btnClickedHandler(_event, action) {
		if (action == 'signup') {  // NOSONAR
			this.params.context.componentParent.Signup(this.params.data.kpiId, this.params.data.userId, this.params.data.route);
		}

	}

	ngOnDestroy() {
console.info()


	}
}
